import React, { Component } from "react";
import { Switch, Grid, withStyles, Typography } from "@material-ui/core";

const FilterNameTypography = withStyles({
  root: {
    color: "#082d66",
  },
})(Typography);

const SwitchTypography = withStyles({
  root: {
    color: "#007bff",
  },
})(Typography);

const FilterSwitch = withStyles({
  checked: {},
  track: {
    backgroundColor: "#007bff",
    opacity: "0.3",
  },
  colorDefault: {
    color: "#007bff",
  },
})(Switch);

const allWord = "všichni";

class SwitchFilter extends Component {
  //a make-do solution using Filter object
  //switching between either both values(currentValues will contain both values) or the second one(currentValues will contain only the second one)
  state = {
    description: this.props.description,
    values: this.props.values, //first is on the left, second on the right
    selectedValues: this.props.selectedValues,
  };

  render() {
    return (
      <div className="filter-box">
        <FilterNameTypography variant="h6" id="switch-filter">
          {this.state.description}
        </FilterNameTypography>
        {/* <ValuesTypography variant="body2">
          {this.printSelectedValue()}
        </ValuesTypography> */}
        <SwitchTypography variant="button" component="div">
          <Grid component="label" container spacing={0} alignItems="center">
            <Grid item>{allWord}</Grid>
            <Grid item>
              <FilterSwitch
                checked={this.rightValueSelected()}
                onChange={this.handleChange}
                color="default"
              />
            </Grid>
            <Grid item>{this.state.values[1]}</Grid>
          </Grid>
        </SwitchTypography>
      </div>
    );
  }

  printSelectedValue = () => {
    if (this.state.selectedValues.length === 1) {
      return this.state.selectedValues[0];
    } else {
      return allWord;
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.selectedValues !== this.props.selectedValues) {
      this.setState({ selectedValues: this.props.selectedValues });
    }
  }

  rightValueSelected = () => {
    return this.state.selectedValues.length === 1;
  };

  handleChange = () => {
    if (this.rightValueSelected()) {
      this.state.selectedValues = [this.state.values[0], this.state.values[1]];
    } else {
      this.state.selectedValues = [this.state.values[1]];
    }
    this.props.changeFilterValue(this.state.selectedValues, this.state.flag);
  };
}

export default SwitchFilter;
